import './App.css';
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Carousel from './Carousel';
import TopMenu from './components/TopMenu';
import SlidingPane from "react-sliding-pane";
import PinContent from "./slide_2/panels/PinContent.jsx";
import { usePinData } from "./data/PinDataContext.jsx";
import "react-sliding-pane/dist/react-sliding-pane.css"; // SlidingPane 기본 CSS

const App = () => {

  const { pinData } = usePinData();
  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
    pinID: "",
    content: [],
    selectedIndex: -1
  });

  const openPanel = (title, subtitle) => {
    
    const result = pinData.find(pin => pin.title === title);
    if (result === undefined || result === null || result.length === 0)
      return false;

    let index = -1;
    if (subtitle) {
      index = result.children.findIndex(child => child.title === subtitle);
      if (index !== -1) {
        result.selectedIndex = index;
      }
    }

    setState({ isPaneOpen: true, content: result, selectedIndex: index });
    return true;
  }

  // panel이 뜰 때 위에 가려지는 메뉴들 제어
  const toggleTopMenu = (isVisible) => {
  
    const topMenus = document.querySelectorAll('.topMenu');
    console.log(topMenus);
    topMenus.forEach(topMenu => {
      if (!isVisible) {
        topMenu.style.display = 'none';
      } else {
        topMenu.style.display = 'flex';
      }
    });
  };

  const closePanel2 = () => {
    setState({ isPaneOpen: false, content: [], selectedIndex: -1 });
  };

  const openModal = () => { }

  return (
    <>
      {/* <TopMenu /> */}
      <Outlet />
      {/* 영상, 이미지, 지도 슬라이딩들*/}
      <div className="bg-dark">
        <Carousel openPanel={openPanel} />
      </div>

      {/* 설명이 나오는 설명창 */}
      <SlidingPane
        className="slide-pane"
        overlayClassName="slide-pane__overlay"
        contentClassName="slide-pane__content"
        width={ "100%" }
        isOpen={state.isPaneOpen}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        hideHeader={true}
        onRequestClose={() => {
          setState({ isPaneOpen: false, content: [], selectedIndex: -1 });
        }}
        onAfterOpen={() => {
          toggleTopMenu(false);
        }}
        onAfterClose={() => {
          toggleTopMenu(true);
        }}
      >
        {state.content !== undefined && <PinContent content={state.content} cb={openModal} closePanel={closePanel2} initialSelectedIndex={state.selectedIndex} />}
      </SlidingPane>
    </>
  );

};

export default App;
